import { useMemo } from "react";
import useStore from "../store/useStore";

// alpha v0.1: shows now come from the api. credit suggestions are reviewed
// server-side, so an approved suggestion already mutated the show doc.
// this hook just returns the base show (api or custom).
export function useMergedShow(id) {
  const apiShows = useStore((s) => s.apiShows);
  const customShows = useStore((s) => s.customShows);
  return useMemo(() => {
    if (!id) return null;
    return (
      (apiShows || []).find((s) => s.id === id) ||
      (customShows || []).find((s) => s.id === id) ||
      null
    );
  }, [id, apiShows, customShows]);
}
